import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

const LabelsInfoDrawer = createDrawer(() => (
  <DrawerSimple>
    <DrawerHeader justify="between">
      <DrawerHeaderTitle title="Add Filtering & Magic labels" />
      <DrawerCloseIcon />
    </DrawerHeader>
    <DrawerBody className={styles.documentationBody} gap="medium">
      <Typography tag="p" variant="p-body2">
        Labels are useful for searching and grouping things, but also work extremely well with
        policies.
      </Typography>
      <Typography tag="h3" variant="p-t6">
        List of the most useful labels:
      </Typography>
      <Typography tag="div" variant="p-body2">
        <ul>
          <li>
            <strong>infracost</strong> → Enables Infracost on your stack
          </li>
          <li>
            <strong>feature:add_plan_pr_comment</strong> → Enables Pull Request Plan Commenting
          </li>
          <li>
            <strong>feature:disable_resource_sanitization</strong> → Disables resource sanitization
          </li>
          <li>
            <strong>terragrunt</strong> → Old way of using Terragrunt from the Terraform backend
          </li>
          <li>
            <strong>ghenv:Name</strong> → GitHub Deployment environment (defaults to the stack name)
          </li>
          <li>
            <strong>ghenv: - </strong> → Disables the creation of GitHub deployment environments
          </li>
          <li>
            <strong>autoattach:label</strong> → Used for policies and contexts to autoattach them to
            all stacks containing that label
          </li>
        </ul>
      </Typography>
    </DrawerBody>
    {/* <DrawerFooter>
    <Button
      // TODO: update docs
      href={getDocsUrl()}
      variant="secondary"
      size="medium"
      target="_blank"
      startIcon={Documentation}
      analyticsTitle="Full documentation Click"
      className={styles.documentationButton}
    >
      Open documentation
    </Button>
  </DrawerFooter> */}
  </DrawerSimple>
));

export const showLabelsInfoDrawer = createDrawerTrigger(LabelsInfoDrawer);
